import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CSubheader,
  CBreadcrumbRouter,
} from "@coreui/react";
import { TheHeaderDropdown } from "./index";
import "./TheHeader.css";
import routes_client from "src/routes/routes_client";

const TheHeader = () => {
  const { sidebarShow } = useSelector((state) => state.sidebarReducer);
  const dispatch = useDispatch();

  const toggleSidebar = () => {
    const val = [true, "responsive"].includes(sidebarShow)
      ? false
      : "responsive";
    dispatch({ type: "SET", payload: val });
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    dispatch({ type: "SET", payload: val });
  };

  return (
    <CHeader fixed={false} withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
      <CHeaderBrand
        className="mx-auto d-lg-none flex justify-content-beetwen"
        to="/"
      >
        <span className="mr-3">
          <b>MKI</b>
        </span>
        <img src={"assets/images/logo-mki.png"} alt="logo-mki" height={30} />
      </CHeaderBrand>

      <CHeaderNav className="d-md-down-none mr-auto"></CHeaderNav>

      <CHeaderNav className="px-3 cok">
        <TheHeaderDropdown />
      </CHeaderNav>

      <CSubheader className="px-3 justify-content-between">
        <CBreadcrumbRouter
          className="border-0 c-subheader-nav m-0 px-0 px-md-3"
          routes={routes_client}
        />
        <div className="d-md-down-none mfe-2 c-subheader-nav"></div>
      </CSubheader>
    </CHeader>
  );
};

export default TheHeader;
